import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import qs from 'qs';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import { GLOBAL_DEFAULT_PAGE_SIZE } from '../../common/constants/CommonConstants';
import { convertFilterToVfl } from '../../common/util/velarisFilterLanguageUtils';
import { fetchAllSuccessPlans } from '../routines/successPlanRoutines';
import { DEFAULT_TABLE_SORT_SETTINGS } from '../../common/constants/SuccessPlanConstants';

const ALL_SUCCESS_PLANS_URL = `${envConfig.APIG_URL}success-plan/all-success-plans`;

function getAllSuccessPlansApiHelper(payload = {}) {
  const {
    page,
    pageSize,
    sortColumn,
    sortDirection,
    query,
    filters,
    mySuccessPlansOnly,
    successPlanEntityType,
    breakdownFilter,
    entityData,
  } = payload || {};

  const params = {
    page: page || DEFAULT_TABLE_SORT_SETTINGS.page,
    pageSize: pageSize || GLOBAL_DEFAULT_PAGE_SIZE,
    mySuccessPlansOnly,
    successPlanEntityType,
    breakdownFilter,
    ...(entityData?.entity && {
      entityId: entityData.entityId,
      level: entityData.level,
    }),
    sortColumn: sortColumn || DEFAULT_TABLE_SORT_SETTINGS.sortColumn,
    sortDirection: sortDirection || DEFAULT_TABLE_SORT_SETTINGS.sortDirection,
  };

  if (filters && filters.length > 0) {
    params.filters = convertFilterToVfl(filters);
  }
  if (query && query.length > 0) {
    params.query = query;
  }

  const url = `${ALL_SUCCESS_PLANS_URL}?${qs.stringify(params)}`;
  return request(url);
}

export function* fetchAllSuccessPlansSaga({ payload }) {
  const { currentPayload: prevPayload } = yield select(
    (state) => state.allSuccessPlans
  );

  const payloadToUse =
    payload && payload.usePrevPayload ? prevPayload : payload;

  try {
    const response = yield call(getAllSuccessPlansApiHelper, payloadToUse);
    yield put(
      fetchAllSuccessPlans.success({
        response: response.data,
        currentPayload: payloadToUse,
      })
    );
  } catch (error) {
    yield put(fetchAllSuccessPlans.failure({ error }));
  } finally {
    yield put(fetchAllSuccessPlans.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchAllSuccessPlans.TRIGGER, fetchAllSuccessPlansSaga),
  ]);
}
